import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Timeline from './pages/Timeline';
import Overview from './pages/Overview';
import Benefits from './pages/Benefits';
import IpadBenefits from './pages/IpadBenefits';
import IpadBeyondBooks from './pages/IpadBeyondBooks';
import MdmExplained from './pages/MdmExplained';
import PengasuhanChecklist from './pages/PengasuhanChecklist';
import ImplementationPhases from './pages/ImplementationPhases';
import RoadmapWhatWhyHow from './pages/RoadmapWhatWhyHow';
import StrategicDecisions from './pages/StrategicDecisions';
import IpadDistribution from './pages/IpadDistribution';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50">
        <Navbar />
        <main className="pt-20">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/timeline" element={<Timeline />} />
            <Route path="/overview" element={<Overview />} />
            <Route path="/benefits" element={<Benefits />} />
            <Route path="/ipad-benefits" element={<IpadBenefits />} />
            <Route path="/ipad-beyond-books" element={<IpadBeyondBooks />} />
            <Route path="/mdm-explained" element={<MdmExplained />} />
            <Route path="/pengasuhan-checklist" element={<PengasuhanChecklist />} />
            <Route path="/implementation-phases" element={<ImplementationPhases />} />
            <Route path="/roadmap-what-why-how" element={<RoadmapWhatWhyHow />} />
            <Route path="/strategic-decisions" element={<StrategicDecisions />} />
            <Route path="/ipad-distribution" element={<IpadDistribution />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
